import Vue from 'vue'
import Vuex from 'vuex'
import VuexReset from '@ianwalter/vuex-reset'

import { firestoreAction, vuexfireMutations } from 'vuexfire'

import { Storage } from '@/utils/Storage'

import { db } from '@/utils/Firebase'

Vue.use(Vuex)

import moment from 'moment';

export default new Vuex.Store({
    plugins: [VuexReset()],
    state: {

        //Common
        preventRouteLeaveFn: null,
        config: null,
        countries: [],
        banks: [],
        plans: [],
        groups: [],
        teams: [],
        firstLoadApp: true,
        evaluations: [],
        libraryTab: null,

        //User
        currentUser: null,
        account: null,
        currentSubscription: null,

        //Coaches
        coaches: [],
        filterCoach: '(accountType:coach AND readyToTrain=1) ',

        //Students
        studentInvitations: [],

        //Loading
        loadingUser: false,
        loadingRoutines: false,

        //Dialog
        dialogActive: false,
        secondDialogActive: false,
        thirdDialogActive: false,
        showConfirm: false,
        needConfirm: false,
        kimsaConfirmTitle: '',
        kimsaConfirmContent: '',

        //Title
        title: '',

        //Routines
        showCalendar: false,
        myAssignedRoutines: [],
        lastRoutines: [],
        routines: [],
        myRoutinesHome: [],
        myRoutines: [],
        currentRoutine: null,
        currentExercise: null,
        assignedRoutinesToday: [],
        routinesStudent: [],
        groupRoutines: [],
        teamGroupRoutines: [],
        currentCarousel: null,
        coachAssignedRoutines: [],
        folders: [],
        globalFolders: [],
        routineNotes: [],

        //Exercises
        categoriesOptions: [],
        loadingCategories: false,
        equipment: [],

        //Snackbar
        snackBarModel: false,
        snackBarText: '',
        snackBarColor: 'success',
        snackBarCloseColor: 'grey lighten-1',

        //Overlay
        overlay: false,
        overlayLoading: false,
        overlayUpdate: false,
        skeleton: false,
        typeSkeleton: '',
    },
    mutations: {
        reset: () => {
        },

        setPreventRouteLeaveFn(state, fn) {
            state.preventRouteLeaveFn = fn
        },

        setCategoriesOptions(state, options) {
            state.categoriesOptions = options
        },

        setLoadingCategoriesOptions(state, loading = false) {
            state.loadingCategories = loading
        },

        async setCurrentUser(state, user) {
            const cleanUser = JSON.parse(JSON.stringify(user))
            await Storage.setUser(cleanUser)
            state.currentUser = cleanUser
        },

        showSnackBar(state, message = '') {
            state.snackBarText = message.text || message
            state.snackBarColor = message.color || 'grey darken-3'
            state.snackBarCloseColor = message.closeColor || 'grey lighten-1'
            state.snackBarModel = true
        },

        setSnackBarModel(state, value) {
            state.snackBarModel = value
        },

        hideSnackBar(state) {
            state.snackBarModel = false
        },

        setLoadingRoutines(state, loading = false) {
            state.loadingRoutines = loading
        },

        clearRoutinesStudent(state) {
            state.routinesStudent = []
        },

        setRoutinesStudent(state, routines) {
            state.routinesStudent = routines
        },

        setGroupRoutines(state, groupRoutines) {
            state.groupRoutines = groupRoutines
        },

        setTeamGroupRoutines(state, teamGroupRoutines) {
            state.teamGroupRoutines = teamGroupRoutines
        },

        setRoutineNotes(state, notes) {
            state.routineNotes = notes
        },

        showOverlay(state, isLoading = false) {
            state.overlay = true
            state.overlayLoading = isLoading
        },

        hideOverlay(state, timeout = 0) {
            setTimeout(() => {
                state.overlay = false
                state.overlayLoading = false
            }, timeout);
        },

        setOverlayUpdate(state, overlay = false) {
            state.overlayUpdate = overlay
        },

        showSkeleton(state, type) {
            state.typeSkeleton = type
            state.skeleton = true
        },

        hideSkeleton(state, timeout = 0) {
            setTimeout(() => {
                state.typeSkeleton = ''
                state.skeleton = false
            }, timeout);
        },

        setLoadingUser(state, isLoading = false) {
            state.loadingUser = isLoading
        },

        setDialogActive(state, active = false) {
            state.dialogActive = active
        },

        setSecondDialogActive(state, active = false) {
            state.secondDialogActive = active
        },

        setThirdDialogActive(state, active = false) {
            state.thirdDialogActive = active
        },

        setNeedConfirm(state, message = '') {
            state.needConfirm = message.confirm
            state.kimsaConfirmTitle = message.title || ''
            state.kimsaConfirmContent = message.content || ''
        },

        setShowConfirm(state, show = false) {
            state.showConfirm = show
        },

        setShowCalendar(state, show = false) {
            state.showCalendar = show
        },

        setFilterCoach(state, filter = '(accountType:coach AND readyToTrain=1) ') {
            state.filterCoach = filter
        },

        setTitle(state, title = '') {
            state.title = title
        },

        setCurrentRoutine(state, routine = null) {
            state.currentRoutine = routine
        },

        setCurrentExercise(state, exercise = null) {
            state.currentExercise = exercise
        },

        setCurrentCarousel(state, carousel = null) {
            state.currentCarousel = carousel
        },

        setFirstLoadApp(state) {
            state.firstLoadApp = false
        },

        async cleanDataStorage() {
            await Storage.setUser(null)
            await Storage.setAccount(null)
        },

        async setCurrentAccount(state, account) {
            const cleanAccount = { ...account }
            await Storage.setAccount(cleanAccount)
            state.account = cleanAccount
        },

        setLibraryTab(state, tab = null) {
            state.libraryTab = tab
        },

        ...vuexfireMutations,
    },
    actions: {

        async getUserAccount({ commit }) {
            const user = await Storage.getUser()
            await commit('setCurrentUser', user)
            const account = await Storage.getAccount()
            await commit('setCurrentAccount', account)
        },

        async fetchRoutinesStudent({ commit }, data) {
            if (!data.studentId) return

            let date = moment(data.date)
            let ref = await db.collection('assignedRoutines')
                .where('studentId', '==', data.studentId)
                .where('rawDate.month', "==", date.format('MM'))
                .where('rawDate.year', "==", date.format('YYYY'))
                .orderBy('date', 'asc')
                .get()

            await commit('setRoutinesStudent', ref.docs.map(doc => ({ id: doc.id, ...doc.data() })))
        },

        async fetchGroupRoutines({ commit }, data) {
            if (!data.groupId) return
            let groupRoutines = []
            // console.log('querying group routines')

            let startDate = data.date
            let endDate = moment(data.date).add(1, 'month').format('YYYY-MM-DD')

            await db.collection('groupAssignedRoutines')
                .where('groupId', '==', data.groupId)
                .where('rawDate.full', ">=", startDate)
                .where('rawDate.full', "<=", endDate)
                .orderBy('rawDate.full', 'asc').get().then(routines => {
                    routines.forEach(routine => {
                        groupRoutines.push({
                            id: routine.id,
                            ...routine.data()
                        })
                    })
                })

            // console.log('groupRoutines', groupRoutines)

            await commit('setGroupRoutines', groupRoutines)
        },

        async fetchTeamGroupRoutines({ commit }, data) {
            if (!data.teamId || data.groupId < 0) return
            let teamGroupRoutines = []
            // console.log('querying team group routines')

            let startDate = data.date
            let endDate = moment(data.date).add(1, 'month').format('YYYY-MM-DD')

            await db.collection('groupAssignedRoutines')
                .where('teamId', '==', data.teamId)
                .where('groupId', '==', data.groupId)
                .where('rawDate.full', ">=", startDate)
                .where('rawDate.full', "<=", endDate)
                .orderBy('rawDate.full', 'asc').get().then(routines => {
                    routines.forEach(routine => {
                        teamGroupRoutines.push({
                            id: routine.id,
                            ...routine.data()
                        })
                    })
                })

            // console.log('teamGroupRoutines', teamGroupRoutines)

            await commit('setTeamGroupRoutines', teamGroupRoutines)
        },

        async fetchRoutineNotes({ commit }, data) {
            let date = moment(data.date)
            let ref = await db.collection('routineNotes')
                .where('studentId', '==', data.studentId)
                .where('groupId', '==', data.groupId)
                .where('teamId', '==', data.teamId)
                .where('rawDate.month', "==", date.format('MM'))
                .where('rawDate.year', "==", date.format('YYYY'))
                .orderBy('date', 'asc')
                .get()

            await commit('setRoutineNotes', ref.docs.map(doc => ({ id: doc.id, ...doc.data() })))
        },

        async fetchExerciseCategories({ commit }) {
            let categoriesOptions = []
            commit('setLoadingCategoriesOptions', true)
            await db.collection('categories').get().then(categories => {
                categories.docs.forEach(category => {
                    categoriesOptions.push({
                        id: category.id,
                        value: category.data().name,
                        ...category.data(),
                    })
                })
            })
            commit('setCategoriesOptions', categoriesOptions)
            commit('setLoadingCategoriesOptions')
        },

        async initUser({ state, commit, dispatch }, user) {
            commit('setLoadingUser', true)
            commit('setCurrentUser', user)
            await dispatch('bindUserAccount', user)
            await dispatch('bindStudentInvitations', user.email)
            await dispatch('bindGroups', user.uid)
            await dispatch('bindTeams', user.uid)
            await dispatch('bindFolders', user.uid)
            setTimeout(() => {
                commit('setLoadingUser', false)
            }, 1000)
        },

        bindStudentInvitations: firestoreAction(async ({ bindFirestoreRef }, email) => {
            return await bindFirestoreRef(
                'studentInvitations',
                db.collection('studentInvitations')
                    .where('studentEmail', '==', email)
                    .orderBy('createdAt', 'desc')
            )
        }),

        bindSubscription: firestoreAction(async ({ bindFirestoreRef }, subscriptionId) => {
            if (!subscriptionId) return null
            return await bindFirestoreRef(
                'currentSubscription',
                db.collection('subscriptions').doc(subscriptionId)
            )
        }),

        bindUserAccount: firestoreAction(async ({ bindFirestoreRef }, user) => {
            return await bindFirestoreRef(
                'account',
                db.collection('users').doc(user.uid)
            ).then(account => {
                Storage.setAccount(account)
            })
        }),

        bindCoachs: firestoreAction(async ({ bindFirestoreRef }) => {
            return await bindFirestoreRef(
                'coaches',
                db.collection('users')
                    .where('accountType', '==', 'coach')
            )
        }),

        bindEquipment: firestoreAction(async ({ bindFirestoreRef }) => {
            return await bindFirestoreRef(
                'equipment',
                db.collection('equipment')
            )
        }),

        bindRoutines: firestoreAction(async ({ commit, bindFirestoreRef }, userId, limit = 4) => {
            if (!userId) return
            commit('setLoadingRoutines', true)
            await bindFirestoreRef(
                'lastRoutines',
                db.collection('assignedRoutines')
                    .where('studentId', '==', userId)
                    .orderBy('date', 'desc')
                    .limit(limit)
            )
            setTimeout(() => {
                commit('setLoadingRoutines', false)
            }, 500);
        }),

        bindAssignedRoutinesToday: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            let today = moment().format('YYYY-MM-DD')
            await bindFirestoreRef(
                'assignedRoutinesToday',
                db.collection('assignedRoutines')
                    .where('coachId', '==', coachId)
                    .where('rawDate.full', '==', today)
                    .limit(4)
            )
        }),

        bindMyRoutinesHome: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'myRoutinesHome',
                db.collection('routines')
                    .where('owner', '==', 'user')
                    .where('coachId', '==', coachId)
                    .limit(4)
            )
        }),

        bindMyRoutines: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'myRoutines',
                db.collection('routines')
                    .where('coachId', '==', coachId)
            )
        }),

        bindMyAssignedRoutines: firestoreAction(async ({ commit, bindFirestoreRef }, data) => {
            if (!data.coachId) return
            commit('setLoadingRoutines', true)

            let startDate = data.date
            let endDate = moment(data.date).add(1, 'month').format('YYYY-MM-DD')

            if (data.studentId) {
                await bindFirestoreRef(
                    'myAssignedRoutines',
                    db.collection('assignedRoutines')
                        .where('coachId', '==', data.coachId)
                        .where('studentId', '==', data.studentId)
                        .where('rawDate.full', ">=", startDate)
                        .where('rawDate.full', "<=", endDate)
                        .orderBy('rawDate.full', 'asc')
                )
            } else {
                await bindFirestoreRef(
                    'myAssignedRoutines',
                    db.collection('assignedRoutines')
                        .where('coachId', '==', data.coachId)
                        .where('rawDate.full', ">=", startDate)
                        .where('rawDate.full', "<=", endDate)
                        .orderBy('rawDate.full', 'asc')
                )
            }

            setTimeout(() => {
                commit('setLoadingRoutines', false)
            }, 500);
        }),

        bindRoutinesStudent: firestoreAction(async ({ commit, bindFirestoreRef }, data) => {
            if (!data.studentId) return

            let startDate = data.date
            let endDate = moment(data.date).add(1, 'month').format('YYYY-MM-DD')

            await bindFirestoreRef(
                'routinesStudent',
                db.collection('assignedRoutines')
                    .where('studentId', '==', data.studentId)
                    .where('rawDate.full', ">=", startDate)
                    .where('rawDate.full', "<=", endDate)
                    .orderBy('rawDate.full', 'asc')
            )
        }),

        bindConfig: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
                'config',
                db.collection('config').doc('builder')
            )
        }),

        bindCountries: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
                'countries',
                db.collection('countries').orderBy('name')
            )
        }),

        bindBanks: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
                'banks',
                db.collection('banks')
            )
        }),

        bindPlans: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
                'plans',
                db.collection('plans').where('type', '==', 'coach').where('active', '==', true).orderBy('amount')
            )
        }),

        bindCompanyPlans: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
                'plans',
                db.collection('plans').where('type', '==', 'company').where('active', '==', true).orderBy('amount')
            )
        }),

        bindGroups: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'groups',
                db.collection('groups')
                    .where('coachId', '==', coachId)
            )
        }),

        bindTeams: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'teams',
                db.collection('teams')
                    .where('coachId', '==', coachId)
            )
        }),

        bindCoachAssignedRoutines: firestoreAction(async ({ commit, bindFirestoreRef }, data) => {
            let startDate = moment(data.date).format('YYYY-MM-DD')
            let endDate = moment(data.date).add(1, 'month').format('YYYY-MM-DD')
            if (data.studentId) {
                await bindFirestoreRef(
                    'coachAssignedRoutines',
                    db.collection('assignedRoutines')
                        .where('coachId', '==', data.coachId)
                        .where('studentId', '==', data.studentId)
                        .where('rawDate.full', ">=", startDate)
                        .where('rawDate.full', "<=", endDate)
                        .orderBy('rawDate.full', 'asc')
                )
            } else {
                await bindFirestoreRef(
                    'coachAssignedRoutines',
                    db.collection('assignedRoutines')
                        .where('coachId', '==', data.coachId)
                        .where('rawDate.full', ">=", startDate)
                        .where('rawDate.full', "<=", endDate)
                        .orderBy('rawDate.full', 'asc')
                )
            }
        }),

        bindFolders: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'folders',
                db.collection('folders')
                    .where('coachId', '==', coachId)
                    .orderBy('createdAt', 'desc')
            )
        }),

        bindGlobalFolders: firestoreAction(async ({ bindFirestoreRef }) => {
            await bindFirestoreRef(
                'globalFolders',
                db.collection('folders')
                    .where('coachId', '==', '')
                    .orderBy('createdAt', 'desc')
            )
        }),

        bindEvaluations: firestoreAction(async ({ bindFirestoreRef }, coachId) => {
            if (!coachId) return
            await bindFirestoreRef(
                'evaluations',
                db.collection('evaluations')
                    .where('coachId', '==', coachId)
            )
        }),

    },
})
